export const PREMIUM_CHART_SIDE_STORAGE_KEY = "premium-chart-side:v1";

export function normalizePremiumChartSide(value) {
  return String(value || "")
    .trim()
    .toLowerCase() === "buy"
    ? "buy"
    : "sell";
}

function readNumericValue(source, key) {
  const value = source?.[key];
  if (value === null || value === undefined || value === "") return null;

  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
}

export function restorePremiumChartSide(
  storage = typeof window !== "undefined" ? window.localStorage : null,
) {
  try {
    if (!storage || typeof storage.getItem !== "function") return "sell";
    return normalizePremiumChartSide(storage.getItem(PREMIUM_CHART_SIDE_STORAGE_KEY));
  } catch (error) {
    return "sell";
  }
}

export function getPremiumChartSideLabel(side) {
  return normalizePremiumChartSide(side) === "buy" ? "Buy" : "Sell";
}

export function getRealtimePremiumValue(payload, side) {
  const keys =
    normalizePremiumChartSide(side) === "buy"
      ? ["buyPremium", "buypremium", "buy_premium"]
      : ["sellPremium", "sellpremium", "sell_premium"];

  for (const key of keys) {
    const value = readNumericValue(payload, key);
    if (value !== null) return value;
  }

  return readNumericValue(payload, "premium");
}

export function buildPremiumChartViewKey({
  isOldContractsMode = false,
  selectedOldSymbol = "",
  timeframe,
  accountSetId = "",
  side = "sell",
}) {
  if (isOldContractsMode) {
    return `old:${selectedOldSymbol || "none"}:${timeframe}:${normalizePremiumChartSide(side)}`;
  }

  return `live:${accountSetId || "none"}:${timeframe}:${normalizePremiumChartSide(side)}`;
}
